import { ReactNode } from 'react';

interface QuizCardProps {
  children: ReactNode;
  className?: string;
}

export const QuizCard = ({ children, className = "" }: QuizCardProps) => {
  return (
    <div className={`bg-card border border-border rounded-2xl p-5 md:p-8 shadow-card ${className}`}>
      {children}
    </div>
  );
};